import React from 'react';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import dashboardIcon from '../../assets/images/header/icons/dashboard.svg';
import usersIcon from '../../assets/images/header/icons/users.svg';
import reportIcon from '../../assets/images/header/icons/reports.svg';
import partnersIcon from '../../assets/images/header/icons/demand_partners.svg';
import blackLogo from "../../assets/logo/helix_black_logo_with_xapads.svg"
function HeaderNewUi() {
    return (
        <>
            <header>
                <div className="container_box--header">
                    <Row gutter={16} className='w-100'>
                        <Col span={12} className='container_box--logo'>
                            <Link to="/" className='logo'><img
                                // src={logo}
                                src={blackLogo}
                                alt='USP' /></Link>
                            <nav>
                                <ul>
                                    <li><Link><img src={dashboardIcon} alt='Dashboard' /> Dashboard</Link></li>
                                    <li><Link className='active'><img src={reportIcon} alt='Reports' /> Reports</Link></li>
                                    <li><Link><img src={usersIcon} alt='Users' /> Users</Link></li>
                                    <li><Link><img src={partnersIcon} alt='Demand Partners' /> Demand Partners</Link></li>
                                </ul>
                            </nav>
                        </Col>
                        <Col span={12} className='container_box--end'>
                            <div className='user_dropdown--symbol'>
                                <span>H</span>
                                <div className="user_dropdown--menu">
                                    <div className="user_dropdown--menu-header">
                                        <h2 className='heading'>Harshil Bhandari</h2>
                                        <p className='text'>harshil@xapads.com</p>
                                    </div>

                                    <div className="user_dropdown--menu-body">
                                        <Link to="/"> Support</Link>
                                        <Link to="/"> Settings</Link>
                                    </div>

                                    <div className="usre_dropdown--menu-footer">
                                        <Link to="/"> Logout</Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </header>
        </>
    )
}

export default HeaderNewUi
